import axios from '../api' // 倒入 api

// 获取用车报表
const getCarorderReport = (params) => {
  return axios({
    url: '/api/report/carorder',
    method: 'GET',
    params,
  })
}

//获取用车统计图表数据
const getCarorderChart = (params) => {
  return axios({
    url: `/api/report/carorder/chart`,
    method: 'GET',
    params,
  })
}

//获取用车明细报表
const getcarorderDetail = (params) => {
  return axios({
    url: `/api/report/carorder/detail`,
    method: 'GET',
    params,
  })
}

//用车明细图标数据
const getCarorderDetailChart = (params) => {
  return axios({
    url: `/api/report/carorder/detail/chart`,
    method: 'GET',
    params,
  })
}

// 获取车务报表
const getCarserviceReport = (params) => {
  return axios({
    url: '/api/report/carservice',
    method: 'GET',
    params,
  })
}

//获取司机用车报表
const getDriverReport = (params) => {
  return axios({
    url: '/api/report/driver/carorder',
    method: 'GET',
    params,
  })
}

//获取司机考勤报表
const getDriverLeaveReport = (params) => {
  return axios({
    url: '/api/report/driver/leave',
    method: 'GET',
    params,
  })
}

//获取疲劳驾驶报表
const getFatigueReport = (data) => {
  return axios({
    url: '/api/report/fatigue',
    method: 'POST',
    data,
  })
}

//获取里程统计列表
const getMileageReport = (data) => {
  return axios({
    url: `/api/report/mileage`,
    method: 'POST',
    data,
  })
}

//获取里程明细列表
const getMileageDetail = (data) => {
  return axios({
    url: `/api/report/mileage/detail`,
    method: 'POST',
    data,
  })
}

//获取里程图表数据
const getMileageChartList = (data) => {
  return axios({
    url: `/api/report/mileage/duration`,
    method: 'POST',
    data,
  })
}

//获取里程明细次数图表数据
const getCountData = (data) => {
  return axios({
    url: `/api/report/mileage/detail/count`,
    method: 'POST',
    data,
  })
}

//获取行驶统计分页数据
const getTravelList = (data) => {
  return axios({
    url: `/api/report/travel/list`,
    method: 'POST',
    data,
  })
}

//获取行驶里程图表数据
const getTravelChart = (data) => {
  return axios({
    url: `/api/report/travel/mileage`,
    method: 'POST',
    data,
  })
}

//获取行驶明细分页数据
const getTravelDetailList = (data) => {
  return axios({
    url: `/api/report/travel/detail`,
    method: 'POST',
    data,
  })
}

//获取行驶明细图表数据
const getTravelDetailChart = (data) => {
  return axios({
    url: `/api/report/travel/detail/count`,
    method: 'POST',
    data,
  })
}

//获取停车统计列表数据
const getParkingList = (data) => {
  return axios({
    url: `/api/report/parking/list`,
    method: 'POST',
    data,
  })
}

//获取停车统计图表数据
const getParkingChart = (data) => {
  return axios({
    url: `/api/report/parking/duration`,
    method: 'POST',
    data,
  })
}

//获取停车明细列表数据
const getParkingDetailList = (data) => {
  return axios({
    url: `/api/report/parking/detail`,
    method: 'POST',
    data,
  })
}

//获取停车明细数图表数据
const getParkingDetailChart = (data) => {
  return axios({
    url: `/api/report/parking/detail/count`,
    method: 'POST',
    data,
  })
}

//获取车辆位置列表数据
const getLocationList = (data) => {
  return axios({
    url: `/api/report/location/list`,
    method: 'POST',
    data,
  })
}

//获取车辆位置图表数据
const getLocationChart = (data) => {
  return axios({
    url: `/api/report/location/count`,
    method: 'POST',
    data,
  })
}

//获取超速报表列表数据
const getSpeedingList = (data) => {
  return axios({
    url: `/api/report/speeding/list`,
    method: 'POST',
    data,
  })
}

//获取超速图表数据数据
const getSpeedingChart = (data) => {
  return axios({
    url: `/api/report/speeding/count`,
    method: 'POST',
    data,
  })
}

//获取超速明细报表列表数据
const getSpeedingDetail = (data) => {
  return axios({
    url: `/api/report/speeding/detail`,
    method: 'POST',
    data,
  })
}

//获取怠速报表列表数据
const getIdleList = (data) => {
  return axios({
    url: `/api/report/idle/list`,
    method: 'POST',
    data,
  })
}

//获取怠速统计图表数据
const getIdleChart = (data) => {
  return axios({
    url: `/api/report/idle/count/chart`,
    method: 'POST',
    data,
  })
}

//获取怠速明细列表数据
const getIdleDetail = (data) => {
  return axios({
    url: `/api/report/idle/detail`,
    method: 'POST',
    data,
  })
}

//获取怠速明细图表数据
const getIdleDetailChart = (data) => {
  return axios({
    url: `/api/report/idle/chart`,
    method: 'POST',
    data,
  })
}
//主动安全-报警排行报表
const getAlarmReport = (data) => {
  return axios({
    url: `/api/report/activesafety/alarmrank/statistic`,
    method: 'POST',
    data,
  })
}
//主动安全-统计报表
const safetjReport = (data) => {
  return axios({
    url: `/api/report/activesafety/statistic`,
    method: 'POST',
    data,
  })
}
//违章查询
const illeageSearch = (data) => {
  return axios({
    url: `/api/violation`,
    method: 'POST',
    data,
  })
}
//违章报表
const illeageReport = (data) => {
  return axios({
    url: `/api/report/violation/statistic`,
    method: 'POST',
    data,
  })
}
//推送查询
const psuhSearch = (code) => {
  return axios({
    url: `/api//config/${code}`,
    method: 'get',
  })
}
//推送设置
const pushSettging = (data) => {
  return axios({
    url: `/api/config`,
    method: 'PUT',
    data,
  })
}
//门磁报表
const getManeticReport = (data) => {
  return axios({
    url: `/api/report/iorecord/statistic`,
    method: 'POST',
    data,
  })
}
//传感器报表
const getSensor = (data) => {
  return axios({
    url: `/api/report/sensor`,
    method: 'POST',
    data,
  })
}

//当前租户点数
const currentTenantPoint = () => {
  return axios({
    url: `/api/tenant/balance`,
    method: 'get',
  })
}

//当前租户消费记录
const cruuentTenantConsume = (data) => {
  return axios({
    url: `/api/tenant/balance/record`,
    method: 'post',
    data,
  })
}
// ! 计费中心部分

const cruuentBalanceBillingCenter = (params) => {
  return axios({
    url: `/api/tenant/balance/billing-center`,
    params,
  })
}

const cruuentBalanceBillingCenterMonth = (params) => {
  return axios({
    url: `/api/tenant/balance/billing-center-month`,
    params,
  })
}

//充值记录
const rechargeRecord = (data) => {
  return axios({
    url: `/api/tenant/balance/recharge/record`,
    method: 'POST',
    data,
  })
}

//获取工时报表报表
const getworktimeList = (params) => {
  return axios({
    url: `/api/report/worktime/list`,
    method: 'GET',
    params,
  })
}
//获取工时明细报表
const getworktimeDetail = (params) => {
  return axios({
    url: `/api/report/worktime/detail`,
    method: 'GET',
    params,
  })
}

const getworktimeListMC = (params) => {
  return axios({
    url: `/api/car-work-duration/report`,
    method: 'GET',
    params,
  })
}
// 开工统计图表
const reportChart = (params) => {
  return axios({
    url: `/api/car-work-duration/report-chart`,
    method: 'GET',
    params,
  })
}
//获取工时明细报表
const getworktimeDetailMC = (params) => {
  return axios({
    url: `/api/car-work-duration/report-detail`,
    method: 'GET',
    params,
  })
}
//获取费用列表
const getRenewList = (data) => {
  return axios({
    url: `/api/tenant/renew/my-list`,
    method: 'POST',
    data,
  })
}
//续费申请
const goRenew = (data) => {
  return axios({
    url: `/api/fee-order/cloud-submit`,
    method: 'POST',
    data,
  })
}
// 默认全部倒出
// 根绝需要进行
export default {
  getCarorderReport,
  getCarserviceReport,
  getDriverReport,
  getDriverLeaveReport,
  getMileageReport,
  getMileageChartList,
  getMileageDetail,
  getCountData,
  getTravelList,
  getTravelChart,
  getTravelDetailList,
  getTravelDetailChart,
  getParkingList,
  getParkingChart,
  getParkingDetailList,
  getParkingDetailChart,
  getLocationList,
  getLocationChart,
  getSpeedingList,
  getSpeedingChart,
  getIdleList,
  getIdleDetailChart,
  getcarorderDetail,
  getCarorderDetailChart,
  getSpeedingDetail,
  getIdleDetail,
  getFatigueReport,
  getIdleChart,
  getCarorderChart,
  getAlarmReport,
  safetjReport,
  illeageSearch,
  illeageReport,
  psuhSearch,
  pushSettging,
  getManeticReport,
  getSensor,
  currentTenantPoint,
  cruuentTenantConsume,
  cruuentBalanceBillingCenter,
  cruuentBalanceBillingCenterMonth,
  rechargeRecord,
  getworktimeList,
  getworktimeDetail,
  getworktimeListMC,
  reportChart,
  getworktimeDetail,
  getRenewList,
}
